import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'

import ActionTypes from '@constants/action_types.js'
import { fieldsApi } from '@api/rtk/fieldsApi.ts'

const fieldsAdapter = createEntityAdapter()

const fieldsSlice = createSlice({
  name: 'fields',
  initialState: fieldsAdapter.getInitialState(),
  extraReducers: builder => {
    builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => {
      const { payload } = action
      if (payload.hasOwnProperty('fields')) {
        fieldsAdapter.upsertMany(state, payload.fields)
      }
    })
    // Add entity when createField endpoint is fulfilled
    builder.addMatcher(fieldsApi.endpoints.createField.matchFulfilled, (state, { payload }) =>
      fieldsAdapter.addOne(state, payload)
    )
    // Remove entity when deleteField endpoint is fulfilled
    builder.addMatcher(fieldsApi.endpoints.deleteField.matchFulfilled, (state, { payload }) =>
      fieldsAdapter.removeOne(state, payload.id)
    )
  },
})

// Export specific selectors instead of the full object
const selectors = fieldsAdapter.getSelectors(state => state.data.fields)
export const selectAllFields = selectors.selectAll
export const selectFieldById = selectors.selectById
export const selectFieldIds = selectors.selectIds
export const selectFieldEntities = selectors.selectEntities
export const selectFieldTotal = selectors.selectTotal

export default fieldsSlice.reducer
